import { PartsLineRow } from './PartsLineRow';
import { usePartsLinesPoContext } from '@/hooks/parts/usePartsLinesPoContext';
import type { PartsLine, PartsLineStatus } from '@/hooks/parts/usePartsLines';
import type { JobOption } from './PartsLineFormDialog';

interface Props {
  lines: PartsLine[];
  onEdit: (line: PartsLine) => void;
  onDelete: (line: PartsLine) => void;
  onStatusChange: (line: PartsLine, next: PartsLineStatus) => void;
  canMutate: boolean;
  emptyText?: string;
  /** Phase 5C — passed through so quick-edit can show the job dropdown. */
  jobOptions?: JobOption[];
}

export function PartsLineList({ lines, onEdit, onDelete, onStatusChange, canMutate, emptyText, jobOptions }: Props) {
  // Phase 7 R5 — batched lookup of PO header info for any linked parts lines.
  // Drives the mandatory PO# + vendor metadata strip on each row.
  const { data: poContextMap } = usePartsLinesPoContext(lines);

  if (lines.length === 0) {
    return (
      <div className="rounded-md border border-dashed bg-muted/20 p-4 text-center text-sm text-muted-foreground">
        {emptyText ?? 'No parts yet.'}
      </div>
    );
  }
  return (
    <div className="space-y-2">
      <div className="grid grid-cols-12 gap-2 px-3 text-[11px] uppercase tracking-wide text-muted-foreground">
        <div className="col-span-4">Part</div>
        <div className="col-span-1 text-right">Qty</div>
        <div className="col-span-1 text-right">Cost</div>
        <div className="col-span-1 text-right">Sell</div>
        <div className="col-span-2 text-right">Line · GP</div>
        <div className="col-span-2">Status</div>
        <div className="col-span-1" />
      </div>
      {lines.map((line) => (
        <PartsLineRow
          key={line.id}
          line={line}
          onEdit={() => onEdit(line)}
          onDelete={() => onDelete(line)}
          onStatusChange={(next) => onStatusChange(line, next)}
          canMutate={canMutate}
          jobOptions={jobOptions}
          poContext={
            line.purchase_order_line_id
              ? poContextMap?.get(line.purchase_order_line_id) ?? null
              : null
          }
        />
      ))}
    </div>
  );
}
